import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledScoreCard } from './SurveyScore.types';

export const StyledScoreContainer = styled.div`
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const StyledScoreDescriptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 0px;
  margin-top: ${rem('8px')};
  width: 100%;
`;

export const StyledScoreDescriptionText = styled.p`
  font-family: 'Nunito';
  font-size: ${rem('16px')};
  font-weight: 400;
  color: #757575;

  @media (max-width: ${rem('580px')}) {
    font-size: ${rem('12px')};
  }
`;

export const StyledScoreCard = styled.button<IStyledScoreCard>`
  padding: ${rem('7px')} ${rem('14px')};
  border: 1px solid ${({ color }) => color};
  border-radius: ${rem('6px')};
  font-size: ${rem('20px')};
  font-family: 'Nunito';
  font-weight: 300;
  cursor: pointer;
  color: #000000;
  background: #ffffff;

  &[aria-pressed='true'] {
    color: #ffffff;
    background: ${({ color }) => color};
  }

  &:focus {
    color: #ffffff;
    background: ${({ color }) => color};
  }

  @media (max-width: ${rem('580px')}) {
    padding: ${rem('4px')} ${rem('8px')};
    font-size: ${rem('12px')};
  }
`;
